import './index.scss';
import {inject, observer} from 'mobx-react';
@inject(({store}) => ({
    toggleShowRules: store.toggleShowRules,
    ymbj: store.ymbj,
    isOppo: store.isOppo
}))
@observer
class MainCover extends React.Component {
    render() {
        const {ymbj, isOppo} = this.props;
        let {headInfo = {}, oppoHeadInfo = {}} = ymbj;
        if(isOppo) {
            headInfo = oppoHeadInfo;
        }
        return(
            <div className="m-maincover">
                <img src={headInfo.picture}/>
                <div className="rules" onClick={this.props.toggleShowRules}></div>
            </div>
        );
    }
}

export default MainCover;